






































import Vue from 'vue';
import Component from 'vue-class-component';
import NavigationTemplate from '@/views/pageskeleton/NavigationTemplate.vue';
import ToolbarTemplate from '@/views/pageskeleton/ToolbarTemplate.vue';
import SnackbarTemplate from '@/views/pageskeleton/SnackbarTemplate.vue';
import {Watch} from 'vue-property-decorator';
import {ONLINE_STATUS_INSTANCE} from '@/services/onlinestatus.service';
import CompanyChangeSearchTemplate from '@/views/pageskeleton/companychange/CompanyChangeSearchTemplate.vue';
import CompanyAndUserIndicatorTemplate from '@/views/pageskeleton/CompanyAndUserIndicatorTemplate.vue';
import NavigationSearchTemplate from '@/views/pageskeleton/NavigationSearchTemplate.vue';

@Component({
  components: {
    CompanyAndUserIndicatorTemplate,
    CompanyChangeSearchTemplate,
    NavigationSearchTemplate,
    SnackbarTemplate,
    NavigationTemplate,
    ToolbarTemplate
  }
})
export default class App extends Vue {
  title = 'Trampolin Frontend';
  routerViewKey: number = 0;

  /*
 We change the key of the view so it get`s destroyed and rebuild / rerendered with a new key.
  */
  @Watch('$store.state.navigation.routeRerenderCounter')
  rerenderCurrentView() {
    ++this.routerViewKey;
  }

  created() {
    ONLINE_STATUS_INSTANCE.startTracking();
  }

  destroyed() {
    ONLINE_STATUS_INSTANCE.endTracking();
  }
}
